module.exports = __webpack_public_path__ + "img/condoms.32454c37.gif";